/* @flow */
import React from "react";

import Gettext from "../common/Gettext";
import { Row, Input, SelectColor, SelectWidth } from "../Popup";

export const initialState = {
  period: 14,
  strokeWidth: 1,
  color: "#feac00"
};

export const indicatorTitle = <Gettext>ATR (Average True Range)</Gettext>;

type Props = {
  indicator: Object,
  activeSelect: String,
  handleClick: Function,
  handleChange: Function,
  handleNumberChange: Function
};

const ATRPopup = (props: Props) => (
  <Row>
    <Input
      label={<Gettext>Period</Gettext>}
      name="period"
      value={props.indicator.period}
      onChange={props.handleNumberChange}
      invalid={props.errors && props.errors.period}
    />
    <SelectColor
      label={<Gettext>Colour</Gettext>}
      name="color"
      value={props.indicator.color}
      activeSelect={props.activeSelect}
      onClick={props.handleClick}
      onChange={props.handleAsIsChange}
    />
    <SelectWidth
      label={<Gettext>Width of lines</Gettext>}
      name="strokeWidth"
      value={props.indicator.strokeWidth}
      activeSelect={props.activeSelect}
      onClick={props.handleClick}
      onChange={props.handleAsIsChange}
    />
  </Row>
);

export default ATRPopup;



// WEBPACK FOOTER //
// ./src/components/Toolbar/ATRPopup.js